
import masterKyouikuhi from './master.kyouikuhi';
import masterNenkinshuunyuu from './master.nenkinshuunyuu';
import masterKounetsuhi from './master.kounetsuhi';
import masterTaishokukin from './master.taishokukin';
import masterNenshuJoushouRitsu from './master.nenshuJoushouRitsu';

const NENKIN_START_AGE = 65; //歳

export default class {
    constructor(store) {
        this.$store = store;
        this.startAge = this.$store.state.setainushi.age *1;
        this.startAgeHaiguusha = this.$store.state.haiguusha.age *1;
        this.nenshu = this.$store.getters.setaiNenshu;
        this.shuunyuuInfo = {
            setainushi:{
                shokugyou: this.$store.state.setainushi.shokugyou,
                nenshuu : this.$store.getters.setainushiNenshu,
                chochiku : this.$store.state.setainushi.chochiku*1,
            },
            haiguusha:{
                shokugyou: this.$store.state.haiguusha.shokugyou,
                nenshuu : this.$store.getters.haiguushaNenshu,
            }
        }
        this.retirementInfo = {
            setainushi:{
                age:this.$store.state.setainushi.retirementAge,
                kingaku: 0,
            },
            haiguusha:{
                age:this.$store.state.haiguusha.retirementAge,
                kingaku: 0,
            }
        }

        //給与上昇率計算用の前年の年収 年1%上昇などのように、数%の上昇なので、万円単位でなく円単位で上昇した金額を計算できるようにする
        this.shuunyuuPreviousAge = {
            setainushi: this.$store.getters.setainushiNenshu * 10000,
            haiguusha: this.$store.state.haiguusha.geshuu*12 * 10000,
        },

        this.mochiieLoanPayment = this.$store.getters.mochiieLoanPaymentPerYear;
        this.okosamaAges = this.$store.getters.okosamaAges;

        this.setaiNinzu = this.$store.getters.setaiNinzu;

        //Debug用に、プロパティにしてみる
        this.shuunyuu = {};
        this.seikatsuhi = {};
        this.kyouikuhi = {};

        this.mochiieTotalLoanPayment = 0;
        this.chintaiTotalPayment = 0;

        this.kyouikuhiUchiwake = [
            // {
            //     totalPayment:2000,
            //     startSetainushiAge: 35,
            //     endSetainushiAge: 48,
            // },
            // {
            //     totalPayment:2000,
            //     startSetainushiAge: 47,
            //     endSetainushiAge: 50,
            // }
        ];

        this.kounetsuhiTotalPayment = 0; //光熱費総額
        this.seikatsuhiTotalPayment = 0; //生活費総額
        this.setaiTotalShuunyuu = 0;
        this.setaiTotalShishutsu = 0; //お住まい>自己資金を含んだトータルの支出
        this.mochiieRuisekiShushi = 0; //各年の収支を加算した累積。世帯主>貯蓄額とお住まい>自己資金を含まない

        this.totalPlusMinus = 0;
        this.shuunyuuMaxWithoutTaishokukin = 0;
        this.shishutsuMax = 0;


        this.mochiieShushi = {};
        this.shusiMinimumPeakAge = 0;
        this.shusiMinimumPeakAgeShushi = 0;

        this.familyNumber = function() {
            let number = 1;
            if (this.$store.state.haiguusha.ari) {
                number += 1;
            }
            if (this.$store.state.okosama.ninzuu) {
                number += this.$store.state.okosama.ninzuu;
            }
            return number;
        }
        this.okosamaNumber = function() {
            if (this.$store.state.okosama.ninzuu) {
                return this.$store.state.okosama.ninzuu;
            }

            return 0;
        }

        this.kariireKikan = this.$store.state.osumai.kikan*1;
    }

    shusi() {
        let mochiieData = [];
        let mochiieNuriData = [];

        let shuunyuuData = [];
        let shishutsuData = [];

        //収入
        this.shuunyuu = this.shuunyuuCalc(this.startAge, this.startAgeHaiguusha, this.shuunyuuInfo, this.retirementInfo);

        //光熱費
        this.kounetsuhi = this.kounetsuhiCalc(this.startAge, this.setaiNinzu);

        //生活費
        this.seikatsuhi = this.seikatsuhiCalc(this.startAge,this.nenshu);

        //教育費
        this.kyouikuhi = this.kyouikuhiCalc(this.startAge, this.okosamaAges);

        //教育費の内訳を作る
        this.kyouikuhiUchiwake = this.setKyouikuhiUchiwake(this.startAge, this.okosamaAges);

        //住居費
        let mochiieShishutsu = this.mochiieShishutsuCalc(this.startAge, this.mochiieLoanPayment);

        for (let i=this.startAge; i<=90; i++) {

            let shishutsu = this.kounetsuhi[i] + this.seikatsuhi[i] + this.kyouikuhi[i] + mochiieShishutsu[i];
            this.setaiTotalShishutsu += shishutsu;

            this.shishutsuMax = Math.max(this.shishutsuMax, shishutsu);

            let shuushi = this.shuunyuu[i] - shishutsu;
            if (shuushi>0) {
                this.totalPlusMinus += 1;
            }
            else {
                this.totalPlusMinus -= 1;
            }
            this.mochiieRuisekiShushi += shuushi;

            mochiieData.push([i, this.mochiieRuisekiShushi]);
            mochiieNuriData.push([i, 0, this.mochiieRuisekiShushi]);

            shuunyuuData.push([i, this.shuunyuu[i]]);
            shishutsuData.push([i, shishutsu]);


            this.mochiieShushi[i] = this.mochiieRuisekiShushi;

            //最低金額とその時の年齢の保持用
            if (i === this.startAge) {
                this.shusiMinimumPeakAge = i;
                this.shusiMinimumPeakAgeShushi = shuushi;
            }
            else if (shuushi < this.shusiMinimumPeakAgeShushi && this.kyouikuhi[i]>0) { //結果ページのアドバイスが、「お子さまの入学など教育費が増える」とあるので、教育費がある歳だけを対象とする
                this.shusiMinimumPeakAge = i;
                this.shusiMinimumPeakAgeShushi = shuushi;
            }

        }

        //トータル支出に、お住まい>自己資金を付加する
        this.setaiTotalShishutsu += this.$store.state.osumai.jikoshikin*1;

        return [mochiieData, mochiieNuriData, shuunyuuData, shishutsuData];
    }

    //収入
    shuunyuuCalc(startAge, startAgeHaiguusha, shuunyuuInfo, retirementInfo){

        let data = {};


        for (let i=startAge; i<=90; i++) {
            let shuunyuu = 0;

            let haiguushaAge = i - (startAge - startAgeHaiguusha);

            //年収
            if(retirementInfo.setainushi.age == null || retirementInfo.setainushi.age == '' || retirementInfo.setainushi.age == 0 || i <= retirementInfo.setainushi.age){
                shuunyuu += this.shuunyuuAtAge('setainushi', i);
            }

            if(retirementInfo.haiguusha.age == null || retirementInfo.haiguusha.age == '' || retirementInfo.haiguusha.age == 0 || haiguushaAge <= retirementInfo.haiguusha.age){
                shuunyuu += this.shuunyuuAtAge('haiguusha', haiguushaAge);
            }

            //年金収入
            // console.log(masterNenkinshuunyuu);
            if(i > NENKIN_START_AGE){
                let nenkinSetainushi = masterNenkinshuunyuu[shuunyuuInfo.setainushi.shokugyou];
                if (nenkinSetainushi) {
                    shuunyuu += nenkinSetainushi;
                }
            }

            if(haiguushaAge > NENKIN_START_AGE){
                let nenkinHaigusha = masterNenkinshuunyuu[shuunyuuInfo.haiguusha.shokugyou];
                if (nenkinHaigusha) {
                    shuunyuu += nenkinHaigusha;
                }
            }


            //退職金を加算する前に、収入額の最大値を保持しておく
            this.shuunyuuMaxWithoutTaishokukin = Math.max(this.shuunyuuMaxWithoutTaishokukin, shuunyuu);

            //退職金
            if(i == retirementInfo.setainushi.age && (shuunyuuInfo.setainushi.shokugyou == 1 || shuunyuuInfo.setainushi.shokugyou == 2)){
                retirementInfo.setainushi.kingaku = masterTaishokukin[retirementInfo.setainushi.age];
                shuunyuu += retirementInfo.setainushi.kingaku
            }

            if(haiguushaAge == retirementInfo.haiguusha.age && (shuunyuuInfo.haiguusha.shokugyou == 1 || shuunyuuInfo.haiguusha.shokugyou == 2)){
                retirementInfo.haiguusha.kingaku = masterTaishokukin[retirementInfo.haiguusha.age];
                shuunyuu += retirementInfo.haiguusha.kingaku;
            }


            shuunyuu = Math.floor(shuunyuu);
            data[i] = shuunyuu;
            this.setaiTotalShuunyuu += shuunyuu;
        }

        //90歳までの収入累計額のトータルには、貯蓄額を加算
        this.setaiTotalShuunyuu += shuunyuuInfo.setainushi.chochiku;

        return data;
    }

    shuunyuuAtAge(target,age) {
        // 1年目は上昇率を加算しないので、そのまま返す
        let nenshu = this.shuunyuuPreviousAge[target]*1;

        let upRate = masterNenshuJoushouRitsu[target][age] / 100;
        if (isNaN(upRate)) {
            upRate = 1;
        }
        this.shuunyuuPreviousAge[target] = nenshu * (1+upRate); //単位：円、次年度の計算用に上昇率を加算して保持しておく

        return Math.floor(nenshu/10000); //返却値の単位は万円
    }

    //光熱費 人数によって増減する
    kounetsuhiCalc(startAge, ninzu) {
        // console.log('kounetsuhiCalc ', startAge, ninzu);
        let data = {};

        //世帯人数に対する光熱費年額をマスタから取得
        let kounetsuhiYear = 0;
        if (ninzu <= 4) {
            if (masterKounetsuhi.under4ninSetai[ninzu]) {
                kounetsuhiYear = masterKounetsuhi.under4ninSetai[ninzu];
            }
        }
        else {
            kounetsuhiYear = masterKounetsuhi.under4ninSetai[4] + masterKounetsuhi.over5nin*(ninzu-4);
        }
        kounetsuhiYear = Math.floor(kounetsuhiYear); //整数 円にする

        //未入力状態の場合は、0円
        if (startAge == 0) {
            kounetsuhiYear = 0;
        }

        for (let i=startAge; i<=90; i++) {
            data[i]= kounetsuhiYear;
            this.kounetsuhiTotalPayment += kounetsuhiYear;
        }
        return data;
    }

    //生活費
    seikatsuhiCalc(startAge, nenshu){

        let data = {};

        for (let i=startAge; i<=90; i++) {
            let seikatsuhi = Math.floor(nenshu*0.4);
            data[i]= seikatsuhi
            this.seikatsuhiTotalPayment += seikatsuhi
        }
        return data;
    }

    /**
     * 教育費
     * @param startAge
     * @param ages [8, 3, 1, -1] のような子供の年齢の配列（負数は、◯年後の誕生予定）
     * @returns {{}}
     */
    kyouikuhiCalc(startAge, ages){

        let data = {};

        // console.log(masterKyouikuhi);

        let childAges = ages;

        for (let i=startAge; i<=90; i++) {
            let kyouikuhiOfTheYear = 0;
            let nextAges = [];

            //各年ごとに、子供の数分、ループする forEachのパラメータにその年の子供の年齢(age)を渡す
            childAges.forEach(okosama=>{

                if (masterKyouikuhi[okosama.age] !== undefined && !(okosama.school==1 && okosama.age>=19)) { //高校までの指定で19歳以上は加算しない
                    kyouikuhiOfTheYear += Math.floor(masterKyouikuhi[okosama.age]);
                }
                nextAges.push({'age':okosama.age+1, 'school':okosama.school}); //子供の年齢を+1する

            });
            childAges = nextAges;
            data[i]= kyouikuhiOfTheYear;
        }
        return data;
    }

    /**
     * 教育費
     * @param startAge
     * @param ages [8, 3, 1, -1] のような子供の年齢の配列（負数は、◯年後の誕生予定）
     * @returns {{}}
     */
    setKyouikuhiUchiwake(startAge, ages) {
        let data = [];
        ages.forEach(okosama=>{

            let obj ={
                totalPayment:0,
                startSetainushiAge: startAge,
                endSetainushiAge: startAge,
                school: okosama.school,
            }

            //totalPayment
            for (let i=okosama.age; i<=90; i++) {
                if(i < 0){
                    //endSetainushiAge
                    obj.endSetainushiAge++;
                    continue;
                }
                if(!masterKyouikuhi[i]){
                    //最終年のインクリメント分を引きます。
                    obj.endSetainushiAge -= 1;
                    break;
                }
                if (!(okosama.school==1 && i>=19)) {  //高校までの指定で19歳以上は加算しない
                    obj.totalPayment += Math.floor(masterKyouikuhi[i]);
                }
                // console.log(i);

                //endSetainushiAge
                obj.endSetainushiAge++;
            }

            //startSetainushiAge
            if(okosama.age < 0){
                obj.startSetainushiAge += okosama.age*(-1);
            }

            //グラフに出す学校のテキストの生成
            let schoolText = ''
            if (okosama.age <= 22) {
                schoolText = ' (';

                if (okosama.age <= 3) {
                    schoolText += '保⇒幼⇒小⇒中⇒高';
                }
                else if(okosama.age <= 6) {
                    schoolText += '幼⇒小⇒中⇒高';
                }
                else if(okosama.age <= 12) {
                    schoolText += '小⇒中⇒高';
                }
                else if(okosama.age <= 18) {
                    schoolText += '高';
                }

                //未選択の場合は大学まで
                if (okosama.school != 1) {
                    schoolText += (schoolText === ' (') ? '大':'⇒大';
                }
                schoolText += ') ';
            }

            obj.schoolLadder = schoolText;


            data.push(obj);
        });
        // console.log(data);

        return data;
    }

    //住居費
    mochiieShishutsuCalc(startAge, loanPayment) {
        let data = {};
        let totalPayment = 0;

        let payment = loanPayment;
        for (let i=startAge; i<=90; i++) {

            if (i == (startAge + this.kariireKikan)) {
                payment = 0;
            }

            data[i]=payment;
            totalPayment += payment;
        }
        this.mochiieTotalLoanPayment = totalPayment;
        return data;
    }

    chintaiShishutsuCalc(startAge, juukyohi) {
        let data = {};
        let totalPayment = 0;

        for (let i=startAge; i<=90; i++) {
            data[i]=juukyohi;
            totalPayment += juukyohi
        }

        this.chintaiTotalPayment = totalPayment;
        return data;
    }


    /**
     * 毎月返済額から借入可能額を計算する
     * 参照：
     * 住宅ローン計算式も分かる，利息計算，債務返済方法の算式
     * http://www5d.biglobe.ne.jp/Jusl/Keisanki/JTSL/Loan.html
     *
     * @param monthlyPayment 毎月返済額 単位：円（万円ではない）
     * @param kinri 金利 年利を%で指定
     * @param hensaiKikan 返済期間 年で指定（基本は50年だが、返済開始が遅いと50年より短い場合がある）

     */
    kariireKanouGaku(monthlyPayment, kinri, hensaiKikan) {
        // 例)
        // 毎月返済：10万円、金利：0.9%、返済期間 35年
        //
        // 100000 * ( (1 + 0.9/100/12)^(35*12) -1 ) / ( 0.9/100/12*(1+0.9/100/12)^(35*12) )
        let mp = Math.pow((1 + kinri/100/12), hensaiKikan*12); //共通金利パーツ

        return Math.round( monthlyPayment * (mp-1) / (kinri/100/12 * mp) );
    }


    kansaiNenrei(){
        let kansaiNenrei = this.startAge + this.kariireKikan;

        if (kansaiNenrei > 80) {
            kansaiNenrei = 80;
        }
        return kansaiNenrei;
    }

}